import { optionRelationship } from '@data'
import { usePatient } from '@hook'
import { FormButton, FormInputField, Modal } from '@ui'
import { Select } from '@ui/SearchInput/Select'
import { createOption, getError, showToast } from '@util'
import { useMemo } from 'react'
import { Controller, FormProvider, useForm } from 'react-hook-form'

type Props = {
  id?: string
  onClose: () => void
}
const options = optionRelationship?.map(item => createOption(item))
export const Emergency = ({ onClose, id }: Props) => {
  const { updatePatient, singleIncluded } = usePatient({ id })
  const emergencyContact = singleIncluded?.find(({ type }) => type === 'contact')?.attributes
  const method = useForm({ defaultValues: emergencyContact })
  const { handleSubmit, control, formState, watch } = method

  const formVal = watch('relationship')

  const updatedOptions = useMemo(() => {
    if (formVal)
      return options.some(({ value }) => value === formVal) ? options : [{ name: formVal, value: formVal }, ...options]

    return options
  }, [formVal])

  const onSubmit = async (formVal: any) => {
    const payload = {
      data: {
        attributes: {
          contact_attributes: {
            ...formVal
          }
        },
        type: 'patient'
      }
    }
    try {
      const data = await updatePatient({ formVal: payload, id: id || '' })
      showToast('Patient updated successfully')
      onClose()
    } catch (error) {
      getError(error)
    }
  }
  return (
    <FormProvider {...method}>
      <Modal onClose={onClose} onSubmit={handleSubmit(onSubmit)} title="Emergency Details">
        <form className="w-full min-w-0 max-w-[500px] flex flex-col">
          <div className="p-6 flex flex-col gap-4 overflow-auto">
            <div className="">
              <FormInputField label="Name" name="name" />
            </div>
            <Controller
              control={control}
              name="relationship"
              render={({ field: { onChange, value } }) => (
                <Select
                  borderRadius={'100px'}
                  getOptionValue={({ value }) => value}
                  isCreatable
                  label="Relationship"
                  onChange={(val: any) => onChange(val?.value)}
                  options={updatedOptions}
                  value={updatedOptions.find(({ value: val }) => val === value)}
                />
              )}
            />
            <div className="">
              <FormInputField label="Phone Number" name="phone_number" type="number" />
            </div>
            <div className="">
              <FormInputField label="Email" name="email" type="email" />
            </div>
          </div>
          <FormButton isLoading={formState.isSubmitting} onClose={onClose} submit="Save" />
        </form>
      </Modal>
    </FormProvider>
  )
}
